import Layout from '@/layout';
var artEventRouter = {
  path: '/artEvent',
  component: Layout,
  redirect: '/artEvent/organizer',
  name: 'ArtEvent',
  alwaysShow: true,
  meta: {
    title: '艺术赛事'
  },
  children: [{
    path: 'organizer',
    component: function component() {
      return import('@/views/marketing/artEvent/organizer');
    },
    name: 'ArtEventOrganizer',
    meta: {
      title: '主办方审核'
    }
  }, {
    path: 'activity',
    component: function component() {
      return import('@/views/marketing/artEvent/activity');
    },
    name: 'ArtEventActivity',
    meta: {
      title: '赛事审核'
    }
  }, {
    path: 'order',
    component: function component() {
      return import('@/views/marketing/artEvent/order');
    },
    name: 'ArtEventOrder',
    meta: {
      title: '报名订单'
    }
  }]
};
export default artEventRouter;